export default __webpack_public_path__ + "static/media/cart_smart_customer.9c60b983.webp";